import { combineReducers } from 'redux'
import cityConfig from './cityConfig'
export default combineReducers({
  cityConfig
})